define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/Actions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    byId: Immutable.Map(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_MEDIAS] = (state, action) => {
    const medias = action.medias;
    const mediasById = _.indexBy(medias, 'id');

    return state.set('byId', Immutable.fromJS(mediasById));
  };

  return Util.createReducer(initialState, actionHandlers);
});
